var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('AToast',{attrs:{"dataTestId":"toast","left":""},model:{value:(_vm.toast),callback:function ($$v) {_vm.toast=$$v},expression:"toast"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }